// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__38in_","info":"UpdateTermsInfo_info__1uFmx"};